import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getTypeOperationActionAsync } from '../redux/actions/TypeOperationActions'

export const useTypeOperation = () => {
  const { typeOperationState } = useSelector(
    (state: RootState) => state.typeOperation
  )
  const dispatch = useDispatch()

  const getTypeOperation = () => {
    dispatch(getTypeOperationActionAsync())
  }

  return { typeOperationState, getTypeOperation }
}
